// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__BX3b8","first":"Hero_first__-Zyor","fadeIn":"Hero_fadeIn__AqM9V"};